const DEFAULT_THRESHOLD = "3";
const DEFAULT_PERCENTAGE = "10";
const MAX_GROUP_SIZE = 2147483647;

const TWO_DECIMALS = /^\d+(\.\d{1,2})?$/;

export function initialGroupDiscount(classInstance) {
  const threshold = classInstance?.group_discount_threshold;
  const percentage = classInstance?.group_discount_percentage;
  return {
    group_discount_enabled: !!classInstance?.group_discount_offered,
    group_discount_threshold: threshold ? String(threshold) : DEFAULT_THRESHOLD,
    group_discount_percentage: Number(percentage) > 0 ? String(Number(percentage)) : DEFAULT_PERCENTAGE,
  };
}

export function groupDiscountErrors(form) {
  if (!form.group_discount_enabled) return {};
  const errors = {};
  const size = Number(form.group_discount_threshold);
  const percent = Number(form.group_discount_percentage);
  if (!Number.isInteger(size) || size < 2 || size > MAX_GROUP_SIZE) errors.threshold = "Enter a whole number of 2 or more.";
  if (!TWO_DECIMALS.test(String(form.group_discount_percentage)) || !(percent >= 1 && percent <= 100)) {
    errors.percentage = "Enter a percentage from 1 to 100, with up to 2 decimal places.";
  }
  return errors;
}

export function groupDiscountPayload(form) {
  if (!form.group_discount_enabled) return { group_discount_threshold: null, group_discount_percentage: null };
  return {
    group_discount_threshold: Number(form.group_discount_threshold),
    group_discount_percentage: Number(form.group_discount_percentage),
  };
}

export function groupDiscountSummary(form) {
  if (!form.group_discount_enabled) return "None";
  return `${Number(form.group_discount_percentage)}% off each spot for groups of ${Number(form.group_discount_threshold)} or more`;
}
